import { axiosInstance } from "@/lib/axios";

export const searchProducts = async (payload: {
    q?: string;
    page?: number;
    limit?: number;
    sort?: string;
    minPrice?: number;
    maxPrice?: number;
    categoryIds?: string[];
    inStock?: boolean;
}) => {
    const { data } = await axiosInstance.post("/products/search", payload);

    return data;
};